export default __webpack_public_path__ + "static/media/4109.919a6657.png";